import { useTranslation } from 'react-i18next';

export interface TotalResultsProps {
  total: number;
  className?: string;
}

export const TotalResults = ({ total, className = '' }: TotalResultsProps) => {
  const { t } = useTranslation('ui');

  return (
    <div className={`text-sm text-complementary-text py-1 ${className}`}>
      {t('virtualTable.totalResults', { count: total })}
    </div>
  );
};
